module.exports = __webpack_public_path__ + "img/aotga.02f56015.png";